export class BomComponentNameValidator {
  public static readonly pattern = '^[a-z0-9-_]+$'
}
